export default __webpack_public_path__ + "static/media/testimonials@2x.a429d368.png";